import React, { Component } from "react";
import { connect } from "react-redux";
import serialize from "form-serialize";

import CustomDatepicker from "../Datepicker/CustomDatepicker";
import CustomSelect from "../CustomSelect";
import CustomSelectSearchable from "../CustomSelectSearchable";

class SearchFilters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newCallsDate: new Date(),
      selected: [],
      category: [],
      culture: [],
      callFrom: null,
      callTo: null,
      lastCallFrom: null,
      lastCallTo: null
    };
  }

  handleClientSelect = e => null;

  handlePageChange = paginator => null;

  handleSelectAllChange = e => {
    const checked = e.target.checked;
    const selected = checked
      ? this.props.list.map(client => client.id.toString())
      : [];

    this.setState({ selected });
  };

  handleCallsDateChange = date => {
    this.setState({
      newCallsDate: date
    });
  };

  updateCallsDates = () => null;

  handleSelectChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  handleDateUpdate = (field, date) => {
    this.setState({
      [field]: date
    });
  };

  setCallFrom = date => {
    this.handleDateUpdate("callFrom", date);
  };

  setCallTo = date => {
    this.handleDateUpdate("callTo", date);
  };

  setLastCallFrom = date => {
    this.handleDateUpdate("lastCallFrom", date);
  };

  setLastCallTo = date => {
    this.handleDateUpdate("lastCallTo", date);
  };

  onSubmit = e => {
    e.preventDefault();
    const { options } = this.props;
    const data = serialize(this.form, { hash: true });
    if (options.length < 2) {
      data.type = ["1"];
    } else {
      data.type = this.props.types;
    }
    if (this.state.category.length) {
      data.category = this.state.category.join(" ");
    }
    if (this.state.culture.length) {
      data.culture = this.state.culture.join(" ");
    }
    this.props.onSubmit({ ...data });
    console.log("DATA", data);
  };

  render() {
    const { selectsData } = this.props;
    return (
      <div>
        <form
          action=""
          method=""
          id="do-search"
          className="custom-form filter clearfix"
          ref={c => (this.form = c)}
        >
          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Название</div>
              <div className="col-xs-6 mr-left-20">
                <input type="text" className="custom-form__input" name="name" />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Культура</div>
              <div className="col-xs-6 mr-left-20">
                {selectsData ? (
                  <CustomSelectSearchable
                    name="culture"
                    options={selectsData.cultures}
                    onSelect={this.handleSelectChange}
                    values={this.state.culture}
                    placeholder="Выберите культуру"
                    multiple
                  />
                ) : null}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Цена</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">от</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="price_from"
                    className="custom-form__input"
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="price_to"
                    className="custom-form__input"
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Телефон</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="phone"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Адрес</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="address"
                />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">
                Владелец <br />
                контакта
              </div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="contact_owner"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Звонили</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">c</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="last_call_from"
                    selectedDay={this.state.lastCallFrom}
                    onDayChange={this.setLastCallFrom}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="last_call_to"
                    selectedDay={this.state.lastCallTo}
                    onDayChange={this.setLastCallTo}
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Номер</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="number"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Позвонить</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">с</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="call_from"
                    selectedDay={this.state.callFrom}
                    onDayChange={this.setCallFrom}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="call_to"
                    selectedDay={this.state.callTo}
                    onDayChange={this.setCallTo}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex"
              }}
            >
              <div style={{ marginRight: 30 }}>
                НДС <input type="checkbox" name="is_work_vat" />
              </div>
              <div style={{ marginRight: 30 }}>
                Без НДС <input type="checkbox" name="is_work_no_vat" />
              </div>
              <div style={{ marginRight: 30 }}>
                Договор <input type="checkbox" name="contract" />
              </div>
              <div>
                Звонил последним <input type="checkbox" name="call_by_me" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div
                type="submit"
                formTarget="do-search"
                className="btn btn-success pull-right"
                onClick={this.onSubmit}
              >
                Применить
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectsData: state.webInterface.initData
});

export default connect(mapStateToProps)(SearchFilters);



// WEBPACK FOOTER //
// ./components/SearchFilters/index.js